/**
 * Formats a Date as YYYY-MM-DD in the user's local timezone (toISOString() would use UTC).
 */
export function toLocalIsoDate (d: Date): string {
	const y = d.getFullYear()
	const m = String(d.getMonth() + 1).padStart(2, '0')
	const day = String(d.getDate()).padStart(2, '0')
	return `${y}-${m}-${day}`
}

/**
 * Formats an ISO date string for available-date display.
 * If the date is in the past (or today), returns "Now".
 * Otherwise returns the date formatted as "Month DD, YYYY" (e.g. "June 03, 2026").
 */
export function formatAvailableDate (isoDate: string): string {
	const date = new Date(isoDate + 'T00:00:00')
	const today = new Date()
	today.setHours(0, 0, 0, 0)

	if (date <= today) return 'Now'

	const month = date.toLocaleDateString('en-US', { month: 'long' })
	const day = String(date.getDate()).padStart(2, '0')
	const year = date.getFullYear()

	return `${month} ${day}, ${year}`
}

/**
 * Resolves the default move-in date for a unit as an ISO (YYYY-MM-DD) string.
 * If the unit's available-on date is missing or in the past, defaults to today.
 * Otherwise returns the future available-on date.
 */
export function defaultMoveInDate (availableOn: string | null): string {
	const today = new Date()
	today.setHours(0, 0, 0, 0)

	if (!availableOn) return toLocalIsoDate(today)

	const available = new Date(availableOn + 'T00:00:00')
	if (Number.isNaN(available.getTime()) || available <= today) return toLocalIsoDate(today)

	return availableOn
}
